// extracted by mini-css-extract-plugin
module.exports = {"useSpecials":"UseSpecials_useSpecials__gwzzp"};